import React from 'react';

type BottomSheetProps = {
  open: boolean;
  title?: string;
  children: React.ReactNode;
  onClose: () => void;
};

export function BottomSheet({ open, title, children, onClose }: BottomSheetProps) {
  React.useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose, open]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="ttbBottomSheetRoot"
    >
      <div
        onClick={onClose}
        className="ttbBottomSheetOverlay"
      />
      <div
        className="ttbBottomSheetPanel"
      >
        <div className="ttbBottomSheetHeader">
          <div className="ttbGrow">
            {title ? (
              <div className="ttbBottomSheetTitle">{title}</div>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Закрыть"
            className="ttbBottomSheetClose"
          >
            ×
          </button>
        </div>

        <div className="ttbBottomSheetBody">{children}</div>
      </div>
    </div>
  );
}
